import * as React from "react";
import { Route } from "react-router-dom";
import { Admin, Resource, CustomRoutes, defaultTheme } from "react-admin";
import { deepmerge } from "@mui/utils";
import authProvider from "./Providers/authProvider";
import { strapiProvider } from "./Providers/strapiProvider";
import { CustomLayout as Layout } from "./Layout/Layout";

// Resource views
import ClientList from "./Sections/Clients/ClientList";
import ClientEdit from "./Sections/Clients/ClientEdit";
import ClientCreate from "./Sections/Clients/ClientCreate";
import ClientShow from "./Sections/Clients/ClientShow";
import RequestList from "./Sections/Requests/RequestList";
import Reports from "./Sections/Reports/Reports";
import DuplicateList from "./Sections/Duplicates/DuplicateList";
import DuplicateMerge from "./Sections/Duplicates/DuplicateMerge";
import { EmailList, EmailEdit, EmailCreate } from "./Sections/Emails/Emails";
import EmailIcon from "@mui/icons-material/Email";
import {
	SegmentList,
	SegmentCreate,
	SegmentEdit,
} from "./Sections/Segments/Segments";
import Profile from "./Sections/Profile/Profile";
import FormEdit from "./Sections/Form/FormEdit";
import {
	SuggestionList,
	SuggestionEdit,
} from "./Sections/Suggestions/Suggestions";

// Theme
const theme = deepmerge(defaultTheme, {
	components: {
		MuiFormControl: { defaultProps: { fullWidth: undefined } },
		MuiTextField: { defaultProps: { fullWidth: undefined } },
		MuiAutocomplete: { defaultProps: { fullWidth: undefined } },
		RaSimpleFormIterator: { defaultProps: { fullWidth: undefined } },
		RaTranslatableInputs: { defaultProps: { fullWidth: undefined } },
	},
});

const dataProvider = strapiProvider();

const App = () => (
	<Admin
		theme={theme}
		layout={Layout}
		authProvider={authProvider}
		dataProvider={dataProvider}
	>
		<Resource
			name="clients"
			list={ClientList}
			edit={ClientEdit}
			create={ClientCreate}
			show={ClientShow}
		/>
		<Resource name="requests" list={RequestList} />
		<Resource name="duplicates" list={DuplicateList} edit={DuplicateMerge} />
		<Resource
			name="emails"
			icon={EmailIcon}
			list={EmailList}
			edit={EmailEdit}
			create={EmailCreate}
		/>
		<Resource
			name="segments"
			list={SegmentList}
			create={SegmentCreate}
			edit={SegmentEdit}
		/>
		<Resource name="suggestions" list={SuggestionList} edit={SuggestionEdit} />
		<Resource name="forms" edit={FormEdit} />
		<CustomRoutes>
			<Route path="/reports" element={<Reports />} />
		</CustomRoutes>
		<CustomRoutes>
			<Route path="/profile" element={<Profile />} />
		</CustomRoutes>
	</Admin>
);

export default App;
